
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wa-business",
      function () {
        return require("private-next-pages/wa-business/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wa-business"])
      });
    }
  